import { useSyncExternalStore } from "react";
import { ANSWER_LANGUAGES, DEFAULT_ANSWER_LANG, type AnswerLangCode } from "../lib/languages";

// Panelden secilen "cevap dili". Modul-seviyesi paylasimli store: Settings'te
// degisince App + AnswerView aninda gunceller (useSyncExternalStore). localStorage'da
// kalici + sekmeler arasi senkron. Yalnizca available diller secilebilir.
const KEY = "medregai.answerLang";

function read(): AnswerLangCode {
  if (typeof window === "undefined") return DEFAULT_ANSWER_LANG;
  const saved = localStorage.getItem(KEY) as AnswerLangCode | null;
  const found = ANSWER_LANGUAGES.find((l) => l.code === saved && l.available);
  return found ? found.code : DEFAULT_ANSWER_LANG;
}

let current: AnswerLangCode = read();
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

function setLang(code: AnswerLangCode) {
  const l = ANSWER_LANGUAGES.find((x) => x.code === code);
  if (!l?.available || code === current) return; // sadece available diller
  current = code;
  try {
    localStorage.setItem(KEY, code);
  } catch {
    /* ignore */
  }
  emit();
}

// Sekmeler arasi senkron (baska sekmede degisirse).
if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key === KEY) {
      current = read();
      emit();
    }
  });
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function useAnswerLang() {
  const lang = useSyncExternalStore(subscribe, () => current, () => DEFAULT_ANSWER_LANG);
  return { lang, select: setLang };
}
